import { BaseFieldFilter, NativeFieldFilter } from 'module/api/filter/types';
import { Operation } from 'module/api/filter/types';
import { pascalCase } from 'module/helpers/pascal-case';
import { unreachable } from 'module/helpers/unreachable';
import { BooleanField } from 'module/types/filter-field/field/filterable-field';
import {
  BooleanFieldFilter,
  BooleanFilterOperationType,
} from 'module/types/filter-field/filter/boolean';
import { camelCase } from 'lodash';

const toApiFormat = (filter: BooleanFieldFilter): BaseFieldFilter => {
  const type = camelCase(filter.type) as Operation;

  switch (filter.type) {
    case BooleanFilterOperationType.IsEmpty:
    case BooleanFilterOperationType.IsNotEmpty:
      return { operation: type, sourceType: filter.field.sourceType };
    case BooleanFilterOperationType.IsTrue:
      return {
        operation: Operation.Value,
        value: 'true',
        sourceType: filter.field.sourceType,
      };
    case BooleanFilterOperationType.IsFalse:
      return {
        operation: Operation.Value,
        value: 'false',
        sourceType: filter.field.sourceType,
      };
    default:
      return unreachable(filter.type);
  }
};

const parse = (
  { operation, value }: NativeFieldFilter,
  field: BooleanField,
): BooleanFieldFilter => {
  switch (operation) {
    case Operation.IsEmpty:
    case Operation.IsNotEmpty:
      return {
        field,
        type: pascalCase(operation) as BooleanFilterOperationType,
      };
    case Operation.Value:
      return {
        field,
        type:
          value === 'true'
            ? BooleanFilterOperationType.IsTrue
            : BooleanFilterOperationType.IsFalse,
      };
    default:
      return unreachable(operation as never);
  }
};

export const BooleanFilter = {
  toApiFormat,
  parse,
};
